var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.75 18.75L8.298 11.202M8.298 11.202L0.75 0.75H5.75L11.202 8.298M8.298 11.202L13.75 18.75H18.75L11.202 8.298M18.75 0.75L11.202 8.298",
    stroke: "url(#paint0_linear_7524_126228)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7524_126228",
    x1: 0.75,
    y1: 9.75,
    x2: 18.75,
    y2: 9.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0144231,
    stopColor: "#87959C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0769231,
    stopColor: "#89959C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.139423,
    stopColor: "#8B949B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.211538,
    stopColor: "#B1B3BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#C3C8CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.389423,
    stopColor: "#F1F2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.514423,
    stopColor: "#D2DBE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.634615,
    stopColor: "#D2DBE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.817308,
    stopColor: "#9AB0B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.947115,
    stopColor: "#A5B7C0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.8653000002e15e3a21ede1e50b7492ab.svg";
export { ForwardRef as ReactComponent };